@if (url) {
    <iframe
        scrolling="no"
        sandbox="allow-scripts allow-same-origin"
        [width]="size?.width"
        [height]="size?.height"
        [src]="url | msTrust: 'resourceurl'">
    </iframe>
}
